import React from "react";
import { Alert } from "@mui/material";

const FetchErrorAlert = ({ error }) => {
  if (!error) {
    return null;
  }

  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      <strong>Fetch Failed:</strong> {error}
    </Alert>
  );
};

export default FetchErrorAlert;
